(function () {
    'use strict';
    ImageGalleryManagerController.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', 'ImageData', 'ImageDataExtended', '$mdDialog'];

    function ImageGalleryManagerController($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, ImageData, ImageDataExtended, $mdDialog) {
//
        var $ctrl = this;
        $ctrl.keep_aspect = this.keepAspect || true;
        $ctrl.disableCropping = false || this.disableCropping;
        $ctrl.maxImageCount = this.maxImageCount || 10;
        $ctrl.cropWidth = this.cropWidth || 10;
        $ctrl.cropHeight = this.cropHeight || 10;
        $ctrl.minHeight = this.minHeight || $ctrl.cropHeight;
        $ctrl.minWidth = this.minWidth || $ctrl.cropWidth;
        $ctrl.bounds = {};
        $ctrl.bounds.left = 0;
        $ctrl.bounds.right = 0;
        $ctrl.bounds.top = 0;
        $ctrl.bounds.bottom = 0;
        $ctrl.caption = '';
        $ctrl.description = '';
        var albumInfoEntity;
        $ctrl.editMode = false;
        $ctrl.uploadImage = uploadImage;
        $ctrl.croppedDataUrl = '';
        $ctrl.croppedThumbDataUrl = '';
        $ctrl.sizeType = this.sizeType || 'CLIENT_SIZE';
        $ctrl.imageList = [];

        var imageList = [];
        $scope.$watch('$ctrl.albumId', function (albumId) {
            if ($ctrl.albumId) {

                $ctrl.albumInfoEntity = AlbumInfo.get({id: $ctrl.albumId});
                //$ctrl.imageList = AlbumInfoExtend.findAlbumImages($ctrl.albumId).query();
                $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
            }

        });


        $ctrl.currentImage = {};
        $ctrl.addImage = function () {
            $ctrl.editMode = true;
        }
        $ctrl.canBeAdded = function () {
            if ($ctrl.imageList)
                return ($ctrl.imageList.length >= $ctrl.maxImageCount);
            return false;
        }
        $ctrl.cancelEditing = function () {
            $ctrl.editMode = false;
        }
        $ctrl.deleteImage = function (img) {

            ImageData.delete({id: img.id},
                function () {
                    if ($ctrl.albumId)
                        $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
                });
        }
        $ctrl.imagesrc = function (img) {
            //
            return DataUtils.imagesrc(img.fileDataContentType, img.fileData);
        }

        function addImage() {

        }

        function save() {
            $ctrl.isSaving = true;

            if ($ctrl.albumInfoEntity.id !== null) {
                AlbumInfo.update($ctrl.albumInfo);
            } else {
                AlbumInfo.save($ctrl.albumInfo, function (d) {
                    $ctrl.albumInfoEntity = d;
                });
            }
        }

        function uploadImage() {


            if (!($ctrl.albumInfoEntity && $ctrl.albumInfoEntity.id)) {
                albumInfoEntity = {caption: $ctrl.albumCaption};
                AlbumInfo.save(albumInfoEntity, function (d) {
                    $ctrl.albumInfoEntity = d;
                    $ctrl.albumId = d.id;
                    saveImage();
                }, function (e) {
                    //console.log(e)
                });

            } else {
                saveImage();
            }

        }

        function saveImage() {


            var imageToUpload = {
                caption: $ctrl.caption,
                description: $ctrl.description,
                albumInfoId: $ctrl.albumInfoEntity.id
            }
            imageToUpload.sizeType = $ctrl.sizeType;

            if (!$ctrl.disableCropping) {
                imageToUpload.fileData = $ctrl.croppedDataUrl.split(',')[1];
                imageToUpload.fileDataContentType = 'image/jpeg';
                imageToUpload.thumbnailData = $ctrl.croppedThumbDataUrl.split(',')[1];
            } else {
                console.log('not cropped');
                console.log($ctrl.file);
                imageToUpload.fileData = $ctrl.file.split(',')[1];
                imageToUpload.fileDataContentType = 'image/jpeg';
                imageToUpload.thumbnailData = $ctrl.file.split(',')[1];
            }

            ImageDataExtended.uploadImage().save(imageToUpload, function (imageData) {
                if ($ctrl.albumInfoEntity.id) {
                    // $ctrl.imageList = AlbumInfoExtend.findAlbumImages($ctrl.albumInfoEntity.id).query();
                    $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
                    $ctrl.editMode = false;
                    if ($ctrl.onImageUploaded) {
                        $ctrl.onImageUploaded(imageToUpload);
                    }
                }
            });
        }

        $ctrl.handleFileSelect = function (file) {


            //  var file=evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $ctrl.file = evt.target.result;

                });
            };
            // if(file)
            reader.readAsDataURL(file);
        };

    }


    var ImageGalleryManager = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/image-gallery-manager/eyeson.image-gallery-manager.html',
        controller: ImageGalleryManagerController,
        bindings: {
            label: '<',
            albumId: '=',
            albumCaption: '<',
            cropWidth: '<?',
            cropHeight: '<?',
            minWidth: '<?',
            minHeight: '<?',
            maxImageCount: '<?',
            disableCropping: '<?',
            keepAspect: '<?',
            onImageUploaded: '&?',
            sizeType: '<?'
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('eoImageGalleryManager', ImageGalleryManager)


})();

